import { typography } from '@dentalux/ui-library-core'
import { createUseStyles } from 'react-jss'
import { required } from '../Styles'
import { Theme } from '@mui/material/styles'

export default createUseStyles((theme: Theme) => ({
  radioWrapper: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: 8,
  },
  label: {
    ...typography['Lato Body 1'],
    marginLeft: 16,
    '&:before': required(theme),
  },
  vertical: {
    gridTemplateColumns: '1fr',
    gap: 10,
  },
  flex: {
    display: 'flex',
  },
}))
